<template>
  <div class="home__interact">
    <div class="_box">
      <div class="_col _col--2">
        <div>
          <div class="_title">Подберите резиденции</div>
          <div class="_text texts">
            Специальные условия на резиденции — 20 % до 30.09.2026
          </div>
        </div>
        <a href="/aparts" class="_btn">Подобрать резиденцию</a>
        <div class="_facade">
          <img :src="require('@/assets/img/facades/new/5.2.svg')" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InteractForm",
}
</script>
